<div class="container" [ngClass]="{'show-menu': isShowMenu}">
    <div class="header">
        <img src="/assets/images/brand-header.svg" class="button" routerLink="/" (click)="closeMenu.emit()">
        <span class="material-icons close button"
              (click)="closeMenu.emit()">close</span>
        <span *ngIf="authService.isSuperAdmin && currentCompany" class="mode"> {{currentCompany}}</span>
        <span *ngIf="authService.isSuperAdmin && !currentCompany" class="mode"> M</span>
        <mat-icon *ngIf="authService.isSuperAdmin && currentCompany" class="clear" (click)="resetCompany()" routerLink="/clients"> clear</mat-icon>
        <!-- clear cancel_presentation -->
    </div>
    <div class="link-group">
        <!-- not for super Admin -->

        <div *ngIf="!authService.isSuperAdmin" class="link" routerLink="/client-dashboard/{{currentCompanyId}}">dashboard</div>
        <!-- not for super Admin -->
        <div *ngIf="!currentCompany && authService.isSuperAdmin" class="link" routerLink="/dashboard">dashboard</div>
        <div *ngIf="currentCompany && authService.isSuperAdmin" class="link" routerLink="/client-dashboard/{{currentCompanyId}}">dashboard</div>
        <div
            *ngIf="authService.isSuperAdmin && !currentCompany"
            class="link" routerLink="/clients">Clients</div>
        <div
        *ngIf="authService.isSuperAdmin && !currentCompany"
        class="link" routerLink="/gateways">Gateways</div>
        <div class="link" routerLink="/reports" (click)="closeMenu.emit()">reports</div>
        <div class="link" routerLink="/alert" (click)="closeMenu.emit()">alerts</div>        
        <div class="link" routerLink="/log" (click)="closeMenu.emit()">log</div>
        <div
             *ngIf="authService.isSuperAdmin && !currentCompany"
             class="link" routerLink="/mng-admin" (click)="closeMenu.emit()">Admin</div>
         <div
             *ngIf="authService.isSuperAdmin && !currentCompany"
             class="link" routerLink="/backoffice" (click)="closeMenu.emit()">Backoffice</div>        
        <div
        *ngIf="(authService.isSuperAdmin && currentCompany) || !authService.isSuperAdmin"
        class="link" routerLink="/client-admin" (click)="closeMenu.emit()">Admin</div>
    </div>
    <div class="version">
        {{currentApplicationVersion}}
    </div>
</div>